import { render, staticRenderFns } from "./ApprovisionnementsbyAgence.vue?vue&type=template&id=56bf6c27&"
import script from "./ApprovisionnementsbyAgence.vue?vue&type=script&lang=js&"
export * from "./ApprovisionnementsbyAgence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports